export const environment = {
    production: true,
      // msalConfig: {
      //   auth: {
      //     authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
      //     tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
      //     clientId: 'f568665b-1cff-4eae-a4c1-ebad51207ac4',
      //       authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c'
      //   }
      // },
      // apiConfig: {
      //   scopes: ['user.read'],
      //   uri: 'http://graph.microsoft.com/v1.0/me'
      // },
      // PostLogoutRedirectUri:'http://localhost:4200/#/logout',
      // RedirectUri:'http://localhost:4200/',
      // appcode: 'VTS',
      // serviceBaseUrl: 'http://localhost:50710/api/',
      // tokenPath: 'http://localhost:50710/api/Token',
      // logPageAnalytics: 'N',
      // pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
      // maxSize: 1 * 1024 * 1024, // 1 MB in bytes.
      // instrumentationKey : 'b5a3470b-8c32-45b3-8250-dd5d5ffddbcb' ,//QA -
      // isHostingAzure: true,

    //Azure testing
      //   msalConfig: {
      //     auth: {
      //        clientId: 'f568665b-1cff-4eae-a4c1-ebad51207ac4',
      //        authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c'
      //     }
      //   },
      //   apiConfig: {
      //     scopes: ['user.read'],
      //     uri: 'http://graph.microsoft.com/v1.0/me'
      //   },
      //   PostLogoutRedirectUri:'https://inqa.ey.com/Supplier/#/logout',
      //   RedirectUri:'https://inqa.ey.com/Supplier',
      // appcode: 'VTS',
      // serviceBaseUrl: 'https://inqa.ey.com/Supplier/SupplierAPI/api/',
      // tokenPath: 'https://inqa.ey.com/Supplier/SupplierAPI/api/Token',
      // logPageAnalytics: 'N',
      // pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
      // maxSize: 1 * 1024 * 1024, // 1 MB in bytes,
      //   instrumentationKey : 'b5a3470b-8c32-45b3-8250-dd5d5ffddbcb' ,//QA -


  //Azure UAT
  // production: false,
    //   msalConfig: {
    //     auth: {
    //       authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
    //       tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
    //       clientId: 'f568665b-1cff-4eae-a4c1-ebad51207ac4',
    //         authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c'
    //     }
    //   },
    //   apiConfig: {
    //     scopes: ['user.read'],
    //     uri: 'http://graph.microsoft.com/v1.0/me'
    //   },
    //   PostLogoutRedirectUri:'https://insupplier-uat.ey.net/#/logout',
    //   RedirectUri:'https://insupplier-uat.ey.net',
    // appcode: 'VTS',
    // serviceBaseUrl: 'https://insupplier-uat.ey.net/SupplierAPI/api/',
    // tokenPath: 'https://insupplier-uat.ey.net/SupplierAPI/api/Token',
    // logPageAnalytics: 'N',
    // pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
    // maxSize: 1 * 1024 * 1024, // 1 MB in bytes,
    // instrumentationKey : '306905d2-b24a-4274-bf34-a65c81c66ca3' ,//UAT -
    // isHostingAzure: true,

  //Azure Production
   //production: false,
      msalConfig: {
        auth: {
          authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
          tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
          clientId: 'd358013d-eb82-469e-91e3-d2662d65ba3c',
            authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c'
        }
      },
      apiConfig: {
        scopes: ['user.read'],
        uri: 'http://graph.microsoft.com/v1.0/me'
      },
      PostLogoutRedirectUri:'https://in-supplier.ey.net/#/logout',
      RedirectUri:'https://in-supplier.ey.net',
    appcode: 'VTS',
    serviceBaseUrl: 'https://in-supplier.ey.net/SupplierAPI/api/',
    tokenPath: 'https://in-supplier.ey.net/SupplierAPI/api/Token',
    logPageAnalytics: 'N',
    pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
    maxSize: 1 * 1024 * 1024, // 1 MB in bytes,
    instrumentationKey : 'da37a2a8-0d6c-47e8-8bc8-e7f094c362cf' ,//UAT -
    isHostingAzure: true,

};
 
import 'zone.js/plugins/zone-error';